import http from '../http';

/**
 * get D2D channel list
 * 2024/11/18
 * 
 * @export
 * @param  projectId
 * @returns
 */
function getD2DChannelList(projectId) {
  return http.get(`/d2d/channel/list?projectId=${projectId}`)
}

/**
 * Create D2D channel
 * 2024/11/18
 * 
 * @export
 * @param  designId
 * @param  name
 * @param  projectId 
 * @param  content :{}
 * @returns
 */
function createD2DChannel({ designId, name, projectId, content }) {
  return http.post(`/d2d/channel/create`, { designId: "", name, projectId, content });
}

/**
 * delete D2D channel
 * 2024/11/18
 * 
 * @export
 * @param  d2dChannelId
 * @returns
 */
function deleteD2DChannel({ d2dChannelIds }) {
  // return http.post(`/d2d/channel/delete?d2dChannelId=${d2dChannelIds }`);
  return http.post(`/d2d/channel/delete`, d2dChannelIds);
}

/**
 * get D2D channel content
 * 2024/11/18
 * 
 * @export
 * @param  d2dChannelId
 * @returns
 */
function getD2DChannelContent(d2dChannelId) {
  return http.get(`/d2d/channel/info?d2dChannelId=${d2dChannelId}`)
}

/**
 * update D2D channel content
 * 2024/11/18
 * 
 * @export
 * @param  d2dChannelId
 * @param  content :{}
 * @returns
 */
function updateD2DChannelContent({ d2dChannelId, content }) {
  return http.post(`/d2d/channel/content?d2dChannelId=${d2dChannelId}`, content)
}

function simulationD2D({ d2dChannelId, options }) {
  return http.post(`d2d/channel/simulation?d2dChannelId=${d2dChannelId}&options=${options}`)
}

function getD2DLog(verificationId) {
  return http.get(`d2d/debug/monitor/log?verificationId=${verificationId}`)
}

/**** Result */
/**
 * get result file json
 * 2024/11/18
 * 
 * @export
 * @param  d2dChannelId
 * @param  option 
 * @returns
 */
function getD2DResultInfo({ d2dChannelId, option }) {
  return http.get(`d2d/result/file?d2dChannelId=${d2dChannelId}&option=${option}`)
}

function getD2DResultCurve({ d2dChannelId, params }) {
  return http.post(`/d2d/result/curve/data?d2dChannelId=${d2dChannelId}`, params)
}

function renameD2DChannel({ d2dChannelId, name }) {
  return http.post(`d2d/channel/rename?d2dChannelId=${d2dChannelId}&name=${name}`)
}

function getComplianceResult({ d2dChannelId, option, componentName, pinName, fileName }) {
  return http.get(`d2d/result/file?d2dChannelId=${d2dChannelId}&option=${option}&componentName=${componentName}&pinName=${pinName}&fileName=${fileName}`)
}

export {
  getD2DChannelList,
  createD2DChannel,
  deleteD2DChannel,
  getD2DChannelContent,
  updateD2DChannelContent,
  simulationD2D,
  getD2DLog,
  /* return*/
  getD2DResultInfo,
  getD2DResultCurve,
  renameD2DChannel,
  getComplianceResult
}